import { clsx } from 'clsx';
import { NavLink } from 'react-router-dom';

import { NavigationLinkItem } from './types';

import { forwardRef } from 'react';
import { linkStyle, svg } from './navigationLink.css';
import { buttonText } from './sharedNavStyles.css';

export type NavigationLinkProps = {
  /** The link data to use to render the link. */
  link: NavigationLinkItem;
  /** If the component should render the full or compact UI. */
  compact: boolean;
  /** Optional callback for when a non-disabled navigation link is clicked. */
  onClick?: () => void;
  /** If the link should not be clickable */
  disabled?: boolean;
  // If link should display and icon
  displayIcon?: boolean;
  // additional styling
  className?: string;
};

export const NavigationLink = forwardRef(
  (
    { link: { label, to, icon, disabled }, compact, displayIcon = true, className, onClick }: NavigationLinkProps,
    // Add ref to silence console errors caused by Radix-UI
    _ref,
  ) => {
    return disabled ? (
      <span className={clsx(linkStyle, className)} key={to} aria-disabled={disabled}>
        {displayIcon && <div className={svg}>{icon}</div>}
        {!compact && <span className={buttonText}>{label}</span>}
      </span>
    ) : (
      <NavLink
        className={clsx(linkStyle, className)}
        key={to}
        to={to}
        aria-label={label}
        onClick={onClick}
        end
      >
        {displayIcon && <div className={svg}>{icon}</div>}
        {!compact && <span className={buttonText}>{label}</span>}
      </NavLink>
    );
  },
);
